import { useRecoilState, useSetRecoilState } from "recoil";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { loginState } from "../recoil/auth.atom";
import { UserState } from "../recoil/user.atom";
import { useEffect, useState } from "react";
import {
  LOCAL_STORAGE_ACCESS_KEY,
  LOCAL_STORAGE_PUB_ID,
  LOCAL_STORAGE_SUPER_ADMIN_KEY,
  hasSellerSession,
  isAuthError,
} from "../utils/network";
import { pubState } from "../recoil/pub.atom";
import { sellerPub } from "../api/cafe";
import { authDetail } from "../api/auth";

const PrivateRoute = () => {
  const [isLoggedIn, setIsLoggedIn] = useRecoilState(loginState);
  const setUser = useSetRecoilState(UserState);
  const [isChecking, setIsChecking] = useState(true);
  const setPub = useSetRecoilState(pubState);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_KEY);
    const superAdminToken = localStorage.getItem(LOCAL_STORAGE_SUPER_ADMIN_KEY);

    // 슈퍼 어드민 권한이 있지만 펍 토큰은 없는 경우
    if (superAdminToken && !token) {
      alert("관리자 로그인 되었습니다.");

      // 펍 선택 페이지 이동
      navigate("/login/pub-list");
      setIsChecking(false);
      return;
    }

    if (!token) {
      setIsLoggedIn(false);
      setIsChecking(false);
      return;
    }

    const checkInfo = async () => {
      try {
        const res = await authDetail();

        // 권한이 슈퍼 어드민일  경우
        if (res && res.role === "ROLE_SUPER_ADMIN") {
          localStorage.setItem(
            LOCAL_STORAGE_SUPER_ADMIN_KEY,
            `Bearer ${res.accessToken}`,
          );
          localStorage.removeItem(LOCAL_STORAGE_ACCESS_KEY);
          window.location.reload();
          return;
        }

        // 유저 정보가 없는 경우
        if (!res) {
          setIsChecking(false);
          localStorage.removeItem(LOCAL_STORAGE_ACCESS_KEY);
          setIsLoggedIn(false);
          alert("러너러너와 제휴를 맺어보세요.");
          return;
        }

        setUser(res);

        // 선택된 매장 정보 조회
        try {
          const pubId = localStorage.getItem(LOCAL_STORAGE_PUB_ID);
          if (pubId) {
            const pub = await sellerPub(+pubId);
            if (pub) {
              setPub(pub);
            }
          }
        } catch (e: any) {
          if (isAuthError(e)) {
            localStorage.removeItem(LOCAL_STORAGE_ACCESS_KEY);
            setIsLoggedIn(false);
            alert("로그인이 만료되었습니다.");
            setIsChecking(false);
            return;
          }
        }

        setIsLoggedIn(true);
        setIsChecking(false);
      } catch (e) {
        setIsChecking(false);

        if (isAuthError(e)) {
          localStorage.removeItem(LOCAL_STORAGE_ACCESS_KEY);
          setIsLoggedIn(false);
          alert("로그인이 만료되었습니다.");
          return;
        }

        alert("로그인 정보를 확인하지 못했습니다.");
        setIsLoggedIn(false);
      }
    };

    checkInfo();
  }, [navigate, setIsLoggedIn, setPub, setUser]);

  if (isChecking) {
    return <div>Loading...</div>;
  }

  // 토근은 있지만 매장 선택이 되지 않은 경우 로그인 페이지로 이동
  if (!hasSellerSession()) {
    return <Navigate to="/login" replace />;
  }

  return isLoggedIn ? <Outlet /> : <Navigate to="/login" replace />;
};
export default PrivateRoute;
